import { TWebsiteBuilderElement } from "./element/websiteBuilderElement";
import {
  isWebsiteBuilderMainSection,
  TWebsiteBuilderMainSection,
  TWebsiteBuilderSection,
} from "./section/websiteBuilderSection";
import { IWebsiteBuilderRoot } from "./websiteBuilderRoot";
import { TWebsiteBuilderContainer } from "./container/websiteBuilderContainer";

export interface IWebsiteBuilderNodePosition {
  x: number;
  y: number;
}

export interface IWebsiteBuilderNodeDimensions {
  width: number;
  height: number;
}

export interface IWebsiteBuilderNodeBase {
  id: string;
  type: string;
}

export type TWebsiteBuilderNode =
  | IWebsiteBuilderRoot
  | TWebsiteBuilderSection
  | TWebsiteBuilderContainer
  | TWebsiteBuilderElement;

export type TWebsiteBuilderParentNode = IWebsiteBuilderRoot | TWebsiteBuilderSection | TWebsiteBuilderContainer;

export const isWebsiteBuilderParentNode = (node: TWebsiteBuilderNode): node is TWebsiteBuilderParentNode => {
  return node?.type === "root" || node?.type === "section" || node?.type === "container";
};

export type TWebsiteBuilderElementParentNode = TWebsiteBuilderSection | TWebsiteBuilderContainer;

export const isWebsiteBuilderElementParentNode = (
  node: TWebsiteBuilderNode,
): node is TWebsiteBuilderElementParentNode => {
  return node?.type === "section" || node?.type === "container";
};

export type TWebsiteBuilderCopyableNode =
  | TWebsiteBuilderMainSection
  | TWebsiteBuilderContainer
  | TWebsiteBuilderElement;

export const isWebsiteBuilderCopyableNode = (node: TWebsiteBuilderNode): node is TWebsiteBuilderCopyableNode => {
  return isWebsiteBuilderMainSection(node) || node?.type === "container" || node?.type === "element";
};
